// removed by extract-text-webpack-plugin
module.exports = {"buttonEdit":"_-5ILiFYbruGQwqVJ3ASn4","articleRow":"_4bRBems6MQ0FrTiWfE9rP","title":"_3muTbow8ERCa_y-LhVkW0A","count":"siJ_7bOcZAYCIuzbpXonb","removed":"_10NqeYok1C3Eau0EmaDcZe"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/Bundle/style.scss
// module id = 1067
// module chunks = 0